import { HTMLAttributes, ReactNode, useEffect } from "react";
import { Helmet, HelmetProvider } from "react-helmet-async";
import { APP_NAME } from "../constants/constants";

type Props = {
  title?: string;
  className?: string;
  children: ReactNode;
} & HTMLAttributes<HTMLDivElement>;

const AppLayout: React.FC<Props> = ({
  title,
  className = "",
  children,
  ...rest
}) => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <HelmetProvider>
      <Helmet>
        <title>{title ? `${title} | ${APP_NAME}` : APP_NAME}</title>
      </Helmet>

      <div className={`${className}`} {...rest}>
        {children}
      </div>
    </HelmetProvider>
  );
};

export default AppLayout;
